import React from 'react';
import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Navbar, Nav } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import config from '../config';
import { useLinksContext } from '../context/LinksContext';
import { useOverviewContext } from '../context/OverviewContext';
import "../assets/css/canvasLanding.css";
import imgStrider from "../assets/images/siteImg/canvas-landing/Strider-cropped.png";
import imgSunrays from "../assets/images/siteImg/canvas-landing/Sunrays-rand2.svg";


const CanvasLanding: React.FC = () => {
    const { myAccountLink, olsLink } = useLinksContext();
    const { identityId } = useOverviewContext(); 
    const { oktaAuth, authState } = useOktaAuth();
    const getAccountLink = () => {
        try {
          if (!myAccountLink) {
            console.warn("My Account link is missing.");
            return;
          }
          const cleanUrl = myAccountLink.trim().replace(/^"|"$/g, ""); 
          window.open(cleanUrl, "_blank");
        } catch (error) {
          console.error("Failed to open My Account link:", error);
        }
    };
    const handleLogout = async () => {
        try {
          await oktaAuth.signOut({
            postLogoutRedirectUri: config.oidc.postLogoutRedirectUri, 
          });
          sessionStorage.removeItem("authToken");
        } catch (error) {
          console.error("Logout failed", error);
        }
    };

    useEffect(() => {
        // Add class to body
        document.body.classList.add('landing-page');
    
        // Cleanup: remove class when component unmounts
        return () => {
          document.body.classList.remove('landing-page');
        };
    }, []);

    return(
        <div className="canvas-landing">
            <header>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-end align-items-center">
                                <Navbar className="seconday-menu">
                                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                        <Navbar.Collapse id="responsive-navbar-nav">
                                        <Nav className="ms-auto">
                                            <Nav.Link id="acct" onClick={getAccountLink} className="nav-item">
                                                Account
                                            </Nav.Link>

                                            <Nav.Link id="logout" onClick={handleLogout} className="nav-item">
                                                Logout
                                            </Nav.Link>
                                        </Nav>
                                    </Navbar.Collapse>
                                </Navbar>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
             
            <main>
                
                <div className="content-section">
                    <div id="background" className="sunrays-container">
                        <img
                            id="sunrays"
                            className="rotating"
                            src={imgSunrays}
                            alt=""
                            style={{ width: "165vmax", height: "165vmax" }}
                        />
                        <div id="vista-wrapper">
                            <img
                            id="strider"
                            src={imgStrider}
                            alt="Strider the fox in hiking gear, overlooking the vista"
                            style={{ width: "26.5cqw", height: "auto" }}
                            />
                        </div>
                    </div>
                    <div className="content-grid">
                        <div id="content-wrapper">
                            <h1 className='title'>Welcome! We’re glad you’re here.</h1>
                            <h2 className='sub-title'>Congratulations on getting to this first enrollment milestone!</h2>
                            <p className='description'>Now that your enrollment status is up-to-date, you can take a short break while we work behind the scenes to set up your school experience. We’ll update this page to let you know when it’s time for your next steps. </p>
                            <p className='description'>But for now, sit back, relax, and enjoy the view!</p>
                        </div>
                    </div>
                </div>

                {/* <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="content-wrap">
                                <h1 className='title'>Welcome! We’re glad you’re here.</h1>
                                <h2 className='sub-title'>Congratulations on getting to this first enrollment milestone!</h2>
                                <p className='description'>Now that your enrollment status is up-to-date, you can take a short break while we work behind the scenes to set up your school experience. We’ll update this page to let you know when it’s time for your next steps.</p>
                                <p className='description'>But for now, sit back, relax, and enjoy the view!</p>
                            </div>
                        </div>
                    </div>
                </div> */}
            </main>
           
           <footer>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-6">
                            <ul className="footer-links">
                                <li><a target="_blank" href="https://www.k12.com/terms-of-use/">Terms</a></li>
                                <li><a target="_blank" href="https://www.stridelearning.com/privacy-policy/">Privacy</a></li>
                                <li><a target="_blank" href="https://www.k12.com/ip-policy/">Copyright</a></li>
                                <li><a target="_blank" href="https://www.k12.com/accessibility/">Accessibility</a></li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <div className="copyright text-lg-end">
                                Copyright © 2025 Stride, Inc. All rights reserved.
                            </div>
                        </div>
                    </div>
                </div>
           </footer>
            
        </div>
    );

};
export default CanvasLanding;